import { useQuery } from "@tanstack/react-query";
import { userService } from "@/services/userService";

export const userKeys = {
  all: ['users'],
  list: (page, searchParams) => [...userKeys.all, 'list', page, searchParams],
  single: (id) => [...userKeys.all, id],
  allUsers: () => [...userKeys.all, 'allUsers']
};

export const useUsers = (page = 1, searchParams = {}) => {
  return useQuery({
    queryKey: userKeys.list(page, searchParams),
    queryFn: () => userService.getAllUsers(page, searchParams),
    keepPreviousData: true
  });
};

export const useUser = (id, options) => {
  return useQuery({
    queryKey: userKeys.single(id),
    queryFn: () => userService.getUser(id),
    enabled: !!id,
    ...options,
  });
};

// New hook for fetching all users without pagination for dropdown
export const useAllUsers = (options = {}) => {
  return useQuery({
    queryKey: userKeys.allUsers(),
    queryFn: () => userService.showAllUsers(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    ...options,
  });
}; 